import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import images from './images/images';
import PopUp from '../../../Shared/Popup/PopUp';
import Config from '../../../../Config';
import EpiContext from '@episerver/spa-core/Spa';
import { prepareUrl } from '../../../../utilities/StringHelpers/StringHelpers';
import {
  abroadCountriesSearched,
  setLoading,
  updateTicketFromPackageManager,
  resetSocPackageRemoveStatus,
  saveToHistory,
  setChosenSocForAction,
  clearScreenILAddon,
} from '../cellcomAbroadBlockSlice';

import { updatePackage ,removePackage} from '../Shared/abroadThunk';
import { connect } from 'react-redux';
import { isMobile, isBrowser } from 'react-device-detect';
import CountryPopUp from './PopUps/CountryPopUp';
import CancelPackagePopUp from './PopUps/CancelPackagePopUp';
import CantChangeStartDateFamilyOrCanCancelFamily from './PopUps/CantChangeStartDateFamilyOrCanCancelFamily';
import ChangeStartPackageDatePopup from '../Popups/ChangeStartPackageDatePopup';
import { gaEvent } from '../../../../utilities/analytics/tracking';
import gaParams from '../../../../utilities/analytics/constants';
import AbroadStateInclude from '../Shared/Components/AbroadStateInclude';
import { formatDatesToDifferentFormats, formatDateToMonthFirst, getDayBeforeAndAfter, formatPackageDurationLabel } from '../cellcomAbroadUtilities';
import FailedUpdatePackage from './PopUps/FailedUpdatePackage';
import AbroadTooltip from '../Shared/Components/Tooltip/AbroadTooltip';
import FailedCancelPackage from './PopUps/FailedCancelPackage';
import CannotCancelWhileAbroad from './PopUps/CannotCancelWhileAbroad';
import ImportantPart from '../Shared/Components/ImportantPart';
import { customerTypeEnum, toolTipFamily } from '../cellcomAbroadVariables';
import { AbroadSocType, AddonType } from '../Shared/Models/AbroadPackageModels';
import AddonsCancellationNoticePopup from './PopUps/AddonsCancellationNoticePopup';
import { dwhRemoveAbroadAddon, dwhAbroadAddonExistingPage } from '../../CellcomAbroadLobbyBlock/dwhReports';
import CancelAddonPackagePopUp from './PopUps/CancelAddonPackagePopUp';
import { gaCancelAddonsStep1, gaExistingAddons } from '../../AbroadTicketBlock/gaReports';

function ExistingPackage({
  cellcomAbroad,
  setLoading,
  customerAbroadPackages,
  updateTicketFromPackageManager,
  context,
  packageData,
  otpData,
  removePackage,
  socPackageRemoveStatus,
  businessId,
  privateId,
  goldBusinessSocPackageFolderId,
  mobile,
  updatePackage,
  updatedSocResultStatus,
  resetSocPackageRemoveStatus,
  chosenSocForAction,
  setChosenSocForAction,
  isBusinessIndividual,
  portalsBlock,
  userData,

  clearScreenILAddon,
}) {
  const isDefault = packageData?.isDefault || false;
  const [arrowOpen, setArrowOpen] = useState(isDefault);
  const [popUpDisplay, setPopUpDisplay] = useState('');
  const [extraTopShouldShow, setExtraTopShouldShow] = useState(null);
  const hasImportantDataText = checkHasImportantData();
  const packageDuration = packageData?.abroadPackageClient?.packageDuration;
  const packageDurationUnit = packageData?.abroadPackageClient?.packageDurationUnit;
  const hasStateIncludes = packageData?.abroadPackageClient?.countrySupportedDictionary;
  const packageSocCode = packageData?.abroadPackageClient?.socCode;

  const packageTitle = packageData.customTitle ? packageData.customTitle : 'חבילת חו"ל';

  const popUpObject = {
    showInfoPopUp: 'showInfoPopUp',
    showCancelPackagePopUp: 'showCancelPackagePopUp',
    showAddonsCancellationNoticePopUp: 'showAddonsCancellationNoticePopUp',
    showChangeStartDateFamily: 'showChangeStartDateFamily',
    cantChangeStartDateFamilyOrCanCancelFamily: 'CantChangeStartDateFamilyOrCanCancelFamily',
    showCountriesPopUp: 'showCountriesPopUp',
    failedUpdatePackage: 'failedUpdatePackage',
    updateTripDate: 'updateTripDate',
    showYouCannotCancelPackagePopUp: 'showYouCannotCancelPackagePopUp',
    buyExtendedPackage: 'buyExtendedPackage',
    displayStateInclude: 'displayStateInclude',
    failedCancelPackage: 'FailedCancelPackage',
    showCannotCancelWhileAbroadPopUp: 'showCannotCancelWhileAbroadPopUp',
  };
  const canCancelPackage = packageData.permissions?.canCancelPurchuse;
  const canCancelPackageFamily = packageData.permissions?.canCancelPurchaseFamily;
  const canChangeStartDatePackageFamily = packageData.permissions?.canChangeTripStartDateFamily;
  const canSeeCancel = packageData.permissions?.shouldShowCancelBtn;
  const dateTxt = packageData?.effDateILLocalTime ? packageData.effDateILLocalTime : new Date().toLocaleDateString('He-IL');
  const hasFamilyBonus = packageData?.abroadPackageClient?.isGiveFamilyBonus || false;
  const discountedPackage = packageData?.familyMemberDiscountedPackage || null;
  const familyMembersWithPackages = packageData?.familyMembersWithPackages || [];
  const canPurchaseFamilyPackage = packageData?.canPurchaseFamilyPackage || false;
  const boxesLeft = 5 - familyMembersWithPackages.length;
  //dwh
  const params = {
    channel: cellcomAbroad.activeLobbyTab && cellcomAbroad.activeLobbyTab == 'businessAccount' ? 'WebsiteBusiness' : 'WebsitePrivate',
    param1: cellcomAbroad.isJETAuthentication ? 'JET' : 'WEBSITE',
    param2: packageSocCode,
    param3: cellcomAbroad.selectedAbroadPackage?.isFamilyBonus
      ? 'בני משפחות'
      : cellcomAbroad.epiStyleInitializationData.businessIndividualLobby
        ? 'Individual'
        : '',
    param4: userData?.contactNumber,
    param5: cellcomAbroad.selectedCountries.map((c) => c.countryCode).join(','),
    costumerName: userData?.firstName + ' ' + userData?.lastName,
    idNumber: userData?.IDNumber,
    subscriber: mobile,
  };
  console.log('packageData', userData);

  useEffect(() => {
    if (packageData.socEffactiveDate && checkEffDateBiggerThenToday()) {
      setExtraTopShouldShow(true);
    }



    gaEvent(
      gaParams.ABROAD_MY_ABROAD_PACKAGE_EXISTS_DISPLAY.category,
      gaParams.ABROAD_MY_ABROAD_PACKAGE_EXISTS_DISPLAY.eventType,
      packageSocCode,
    );
    if (packageData.socType == AbroadSocType.ADDON_SOC) {
      dwhAbroadAddonExistingPage({
        message: 'Existing Addon Displayed',
        ...params,
      });
      gaExistingAddons(packageTitle);
    }
  }, []);

  useEffect(() => {
    if (popUpDisplay === popUpObject.updateTripDate) {
      gaEvent(
        gaParams.ABROAD_MY_ABROAD_DISPLAY_CHANGE_START_DATE_POP_UP.category,
        gaParams.ABROAD_MY_ABROAD_DISPLAY_CHANGE_START_DATE_POP_UP.eventType,
        gaParams.ABROAD_MY_ABROAD_DISPLAY_CHANGE_START_DATE_POP_UP.eventParams,
      );
    }
  }, [popUpDisplay]);

  useEffect(() => {
    if (socPackageRemoveStatus === false && chosenSocForAction === packageSocCode) {
      setPopUpDisplay(popUpObject.failedCancelPackage);
    }
  }, [socPackageRemoveStatus, chosenSocForAction]);

  useEffect(() => {
    if (updatedSocResultStatus === false && chosenSocForAction == packageSocCode) {
      setPopUpDisplay(popUpObject.failedUpdatePackage);
    }
  }, [updatedSocResultStatus]);

  function checkHasImportantData() {
    if (
      Array.isArray(packageData?.abroadPackageClient?.importantInfo) &&
      packageData?.abroadPackageClient?.importantInfo.length > 0 &&
      packageData.abroadPackageClient?.importantInfo.every((el) => el != null)
    ) {
      return true;
    } else {
      return false;
    }
  }

  function expendData() {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_PACKAGE_EXISTS_CLICK_EXPAND.category,
      gaParams.ABROAD_MY_ABROAD_PACKAGE_EXISTS_CLICK_EXPAND.eventType,
      packageSocCode,
    );
    setArrowOpen(!arrowOpen);
  }

  function changeDateToJSFormat() {
    const passDate = packageData.socEffactiveDate
      ? `${packageData.socEffactiveDate[4]}${packageData.socEffactiveDate[5]}/${packageData.socEffactiveDate[6]}${packageData.socEffactiveDate[7]}/${packageData.socEffactiveDate[0]}${packageData.socEffactiveDate[1]}${packageData.socEffactiveDate[2]}${packageData.socEffactiveDate[3]}`
      : new Date().toLocaleDateString().replaceAll('.', '-');
    return passDate;
  }

  async function cancelPackage() {
    if (packageData.socType == AbroadSocType.ADDON_SOC) {
      gaCancelAddonsStep1(packageSocCode);
    }
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_CLICK_CANCEL_PACKAGE_POP_UP.category,
      gaParams.ABROAD_MY_ABROAD_CLICK_CANCEL_PACKAGE_POP_UP.eventType,
      gaParams.ABROAD_MY_ABROAD_CLICK_CANCEL_PACKAGE_POP_UP.eventParams,
    );
    const removeSocData = {
      soc: packageSocCode,
      mobile: mobile,
      startDate: packageData.socEffactiveDate,
      isAddon: packageData.socType == AbroadSocType.ADDON_SOC
    };

    const res = await removePackage(removeSocData);

    // Check response directly - if user is abroad, show specific popup
    if (res.payload?.Body?.isSuccess === false && res.payload?.Body?.codeError === 'ABROAD_ACTIVE_PACKAGE') {
      setPopUpDisplay(popUpObject.showCannotCancelWhileAbroadPopUp);
      return;
    }

    // Handle other failures
    if (res.payload?.Body?.isSuccess === false) {
      setPopUpDisplay(popUpObject.failedCancelPackage);
      return;
    }

    // Success case - handle DWH and screen IL addon
    if (packageData.socType == AbroadSocType.ADDON_SOC) {
      if (res.payload?.Body.isSuccess) {
        dwhRemoveAbroadAddon({
          message: 'Success',
          status: 'Completed',
          ...params,
        });
      } else {
        dwhRemoveAbroadAddon({
          message: 'General Error',
          status: 'Error',
          ...params,
        });
      }
    }
    if (packageData.socType == AbroadSocType.REGULAR_SOC) {
      var hasScreenIl = packageData.abroadPackageClient.addons?.find((addon) => addon.type == AddonType.Coupon) !== undefined;
      if (res.payload?.Body.isSuccess && hasScreenIl) {
        clearScreenILAddon();
      }
    }

    closePopUp();
  }

  function displayCancelPopUpAndReportGA() {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_PACKAGE_EXISTS_CLICK_REMOVE_PACKAGE.category,
      gaParams.ABROAD_MY_ABROAD_PACKAGE_EXISTS_CLICK_REMOVE_PACKAGE.eventType,
      packageSocCode,
    );
    if (packageData.socType == AbroadSocType.ADDON_SOC) {
      dwhAbroadAddonExistingPage({
        message: 'Addon Cancel Button Clicked',
        ...params,
      });
    }
    if (!packageData.abroadPackageClient?.isGiveFamilyBonus) {
      if (canSeeCancel && canCancelPackage) {
        packageData.abroadPackageClient.addons?.length > 0
          ? setPopUpDisplay(popUpObject.showAddonsCancellationNoticePopUp)
          : setPopUpDisplay(popUpObject.showCancelPackagePopUp);
      } else if (canSeeCancel && !canCancelPackage) {
        setPopUpDisplay(popUpObject.showYouCannotCancelPackagePopUp);
      }
    } else {
      if (canSeeCancel && canCancelPackage && canCancelPackageFamily) {
        packageData.abroadPackageClient.addons?.length > 0
          ? setPopUpDisplay(popUpObject.showAddonsCancellationNoticePopUp)
          : setPopUpDisplay(popUpObject.showCancelPackagePopUp);
      } else if (canSeeCancel && !canCancelPackage) {
        setPopUpDisplay(popUpObject.showYouCannotCancelPackagePopUp);
      } else if (canSeeCancel && !canCancelPackageFamily) {
        setPopUpDisplay(popUpObject.cantChangeStartDateFamilyOrCanCancelFamily);
      }
    }
  }

  function checkEffDateBiggerThenToday() {
    const effDate = new Date(formatDateToMonthFirst(packageData.socEffactiveDate));
    const today = new Date();
    return effDate > today;
  }

  function setShowCountriesPopUpAndReportGA() {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_PACKAGE_CLICK_HOW_DIFF_STATE_PRICE.category,
      gaParams.ABROAD_MY_ABROAD_PACKAGE_CLICK_HOW_DIFF_STATE_PRICE.eventType,
      packageSocCode,
    );
    setPopUpDisplay(popUpObject.showCountriesPopUp);
  }

  function renderExpendedData(packageData) {
    const defaultOrByUse = packageData.isDefault === true || packageData.abroadPackageClient.isBankOrByUse == 'ByUse';
    return (
      <div className='expended-data-container'>
        {defaultOrByUse && (
          <div className='expended-line' onClick={() => setShowCountriesPopUpAndReportGA()}>
            {'תעריף לפי מדינות > '}
          </div>
        )}
        {hasImportantDataText && !defaultOrByUse ? (
          <div className='expended-line' onClick={() => setPopUpDisplay(popUpObject.showInfoPopUp)}>
            {'חשוב לדעת > '}
          </div>
        ) : (
          <div
            className='abroad-package-client__footer--content--text pr-0'
            onClick={() => (packageData.abroadPackageClient?.policiesEpi ? openAgreementPDF() : showBusinessTerms())}>
            {' '}
            חשוב לדעת
            <span className='abroad-package-client__footer--content--text__arrow'>{`>`}</span>
          </div>
        )}
        {hasStateIncludes && packageData?.abroadPackageClient?.isBankOrByUse != 'ByUse' && (
          <div className='expended-line' onClick={() => setPopUpDisplay(popUpObject.displayStateInclude)}>
            {'מדינות הכלולות בחבילה > '}
          </div>
        )}
      </div>
    );
  }

  function displayPackageText() {
    if (packageData.abroadPackageClient.isBankOrByUse == 'ByUse' || packageData.abroadPackageClient.isDefault)
      return 'במסלול זה התעריף שונה בין המדינות';
  }

  function renderPackageDuration(anyData) {
    if (packageData.isAutoPackage) return null;
    if (packageData.abroadPackageClient.isDefault) {
      return <span className={`package-duration-line${anyData ? ' space' : ''}`}>החבילה תקפה לכל הנסיעה</span>;
    }
    if (packageData.abroadPackageClient.isBankOrByUse == 'ByUse' || packageData.abroadPackageClient.isBankOrByUse == 'Bank') {
      return <span className={`package-duration-line${anyData ? ' space' : ''}`}>{`תחילת החבילה ${dateTxt}`}</span>;
    }
  }

  function renderPackageData(packageData) {
    if (packageData.abroadPackageClient.isDefault) {
      return (
        <>
          <div className='package-data-line'>
            <span className='no-details-list-package-text' style={{ marginLeft: '25px' }}>
              {displayPackageText(packageData)}
            </span>
            {renderPackageDuration(true)}
          </div>
          {arrowOpen && renderExpendedData(packageData)}
        </>
      );
    }
    const packageContainsData =
      packageData.abroadPackageClient && Array.isArray(packageData.abroadPackageClient.packageDetailsList)
        ? packageData.abroadPackageClient.packageDetailsList[0]
        : '';
    const sms = packageContainsData.sms?.unit ? 'SMS' : '';
    const voice = packageContainsData.voice?.unit ? 'שיחות' : '';
    const data = packageContainsData.data?.unit != null ? packageContainsData.data.unit : '';
    const allOfData = data && sms && voice;
    const anyData = data || sms || voice;
    const byUseText =
      packageData.abroadPackageClient.isBankOrByUse == 'ByUse' || packageData.abroadPackageClient.isDefault ? (
        <span
          className={packageData.abroadPackageClient.isBankOrByUse == 'ByUse' ? 'no-details-list-package-text' : ''}
          style={packageData.abroadPackageClient.isBankOrByUse == 'ByUse' ? { marginLeft: '25px' } : {}}>
          {displayPackageText()}
        </span>
      ) : null;
    return (
      <>
        <div className='package-data-line'>
          {data ? (
            <span className={`just-data-line${allOfData ? ' all' : ''}`}>
              {packageContainsData.data?.value}
              {data}&nbsp;
            </span>
          ) : (
            <span className={`just-data-line${!allOfData ? ' empty' : ''}`}>
              {packageContainsData.data?.value}
              {data}
            </span>
          )}
          {sms && data && <div>&nbsp;|&nbsp;</div>}
          {sms && (
            <span>
              &nbsp;{packageContainsData.sms?.value}
              {sms}&nbsp;
            </span>
          )}
          {voice && data && <div>&nbsp;|&nbsp;</div>}
          {voice && (
            <span>
              &nbsp;{packageContainsData.voice?.value} {voice}&nbsp;
            </span>
          )}
          {byUseText}
          {renderPackageDuration(anyData)}
        </div>
        {arrowOpen && displayPackageExpandedDuration()}
        {arrowOpen && renderExpendedData(packageData)}
      </>
    );
  }

  function displayPackageExpandedDuration() {
    if (
      !packageData.socExpDate ||
      (packageData.isBankOrByUse == 'ByUse' && (packageDuration == null || packageDuration == undefined || packageDuration == 0))
    )
      return;

    const durationLine = ` תוקף החבילה שבחרת: ${formatPackageDurationLabel(packageDuration, packageDurationUnit)}, `;
    const dateBeforeEffDate = getDayBeforeAndAfter(formatDateToMonthFirst(packageData.socEffactiveDate), true);
    const dateBeforeExpDate = getDayBeforeAndAfter(formatDateToMonthFirst(packageData.socExpDate), true);
    const startPackage = formatDatesToDifferentFormats(formatDateToMonthFirst(packageData.socEffactiveDate)).formattedUI.slice(0, 5);
    const endPackage = formatDatesToDifferentFormats(formatDateToMonthFirst(packageData.socExpDate)).formattedUI.slice(0, 5);

    if (packageDuration != null) {
      return (
        <div className='package-data-line'>
          {isBrowser ? (
            <>
              <div className='just-data-line' style={{ fontWeight: 'bold' }}>
                {durationLine}
              </div>
              {formatPackageFromToDatesLine(dateBeforeEffDate, dateBeforeExpDate, startPackage, endPackage)}
            </>
          ) : (
            <>
              <div className='just-data-line' style={{ fontWeight: 'bold' }}>
                {durationLine}
              </div>
              {formatPackageFromToDatesLine(dateBeforeEffDate, dateBeforeExpDate, startPackage, endPackage)}
            </>
          )}
        </div>
      );
    }
    return null;
  }

  function formatPackageFromToDatesLine(dateBeforeEffDate, dateBeforeExpDate, startPackage, endPackage) {
    if (isBrowser) {
      return (
        <div className='just-data-line' style={{ marginRight: '-20px' }}>
          החבילה תתחיל ב-<b>{packageData.effDateILLocalTime}</b> בלילה שבין ה-
          {dateBeforeEffDate} ל-{startPackage}&nbsp; ותסתיים ב-
          <b>{packageData.expDateILLocalTime}</b> בלילה שבין ה-
          {dateBeforeExpDate} ל-{endPackage}
        </div>
      );
    }
    return (
      <div className='just-data-line'>
        החבילה תתחיל ב-<b>{packageData.effDateILLocalTime}</b> בלילה שבין ה-
        {dateBeforeEffDate} ל-{startPackage}&nbsp; ותסתיים ב-
        <b>{packageData.expDateILLocalTime}</b> בלילה שבין ה-{dateBeforeExpDate} ל-{endPackage}
      </div>
    );
  }

  function renderPackageWillOccurAt() {
    return extraTopShouldShow && <div className='extra-top'>החבילה תיכנס לתוקף ב {dateTxt}</div>;
  }

  function setUpdateTripDateAndReportGA() {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_PACKAGE_EXISTS_CLICK_DATE_CHANGE.category,
      gaParams.ABROAD_MY_ABROAD_PACKAGE_EXISTS_CLICK_DATE_CHANGE.eventType,
      packageSocCode,
    );
    if (canChangeStartDatePackageFamily) setPopUpDisplay(popUpObject.updateTripDate);
    else setPopUpDisplay(popUpObject.cantChangeStartDateFamilyOrCanCancelFamily);
  }

  function renderPackageAvailableActions(packageData) {
    const canChangeTrip = packageData?.permissions?.canChangeTripStartDate === true || false;
    const canSeeCancelPackageBtn = packageData?.permissions?.shouldShowCancelBtn === true || false;
    const hasAction = canChangeTrip || canSeeCancelPackageBtn;

    if (hasAction) {
      return (
        <div className='action-container'>
          {canChangeTrip && packageData.socType == AbroadSocType.REGULAR_SOC && (
            <div className='action' onClick={() => setUpdateTripDateAndReportGA()}>
              {'עדכון תאריך התחלה > '}
            </div>
          )}
          {canSeeCancelPackageBtn && (
            <div className='action' onClick={() => displayCancelPopUpAndReportGA()}>
              {'ביטול חבילה > '}
            </div>
          )}
        </div>
      );
    }
    return null;
  }

  function closePopUp() {
    setPopUpDisplay('');
  }

  function updateSocPackage(startDate) {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_CLICK_CHANGE_START_DATE_POP_UP.category,
      gaParams.ABROAD_MY_ABROAD_CLICK_CHANGE_START_DATE_POP_UP.eventType,
      gaParams.ABROAD_MY_ABROAD_CLICK_CHANGE_START_DATE_POP_UP.eventParams,
    );
    const d = formatDatesToDifferentFormats(startDate);
    const exp = formatDatesToDifferentFormats(new Date());
    const newUpdatedDate = d.formattedProvider;
    const data = {
      phoneNumber: mobile,
      soc: packageSocCode,
      effDate: packageData.socEffactiveDate,
      expDate: exp.formattedProvider,
      newDateToUpdate: newUpdatedDate,
      businessId: businessId,
      goldBusinessPackagesBlockId: goldBusinessSocPackageFolderId,
      addonsFolderBlockId: cellcomAbroad.epiStyleInitializationData.addonsPackagesFolderId,
    };
    if (isBusinessIndividual) {
      data.isBusinessIndividual = true;
      data.goldBusinessPackagesBlockId = goldBusinessSocPackageFolderId;
      data.orgId = portalsBlock.privateCompanyList.find((org) => org.idNumber == portalsBlock.selectedHetPay).orgId;
    } else {
      data.isBusinessIndividual = false;
      data.privateId = privateId;
    }
    updatePackage(data);
    setChosenSocForAction(packageSocCode);
    closePopUp();
  }

  const localStatePopUpHasValue = () => {
    return popUpDisplay != '' ? true : false;
  };
  const showBusinessTerms = async () => {
    const url = `${Config.termsUrl}?socCode=${packageSocCode}`;
    let win = window.open(url, '_blank');
    win.focus();
  };
  const openAgreementPDF = async () => {
    prepareUrl(packageData.abroadPackageClient?.policiesEpi, EpiContext);
  };
  const GetStartDateParent = (dateParent) => {
    if (dateParent) {
      let year = dateParent.substring(0, 4);
      let month = dateParent.substring(4, 6);
      let day = dateParent.substring(6, 8);
      let date = new Date(year, month - 1, day);
      let rightFormat = formatDatesToDifferentFormats(new Date(date))?.formattedISOS;
      return rightFormat;
    }
  };
  function renderPopUps(packageData) {
    const extraInfoTxt = Array.isArray(packageData?.abroadPackageClient?.importantInfo)
      ? packageData.abroadPackageClient.importantInfo
      : '';
    return (
      <>
        <PopUp showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.failedUpdatePackage} onClose={closePopUp}>
          {popUpDisplay === popUpObject.failedUpdatePackage && <FailedUpdatePackage onClose={closePopUp} />}
        </PopUp>
        <PopUp showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.showInfoPopUp} onClose={closePopUp}>
          {hasImportantDataText && (
            <ImportantPart
              importantInfo={extraInfoTxt}
              policiesEpi={packageData.abroadPackageClient?.policiesEpi}
              showBusinessTerms={showBusinessTerms}
              openAgreementPDF={openAgreementPDF}
            />
          )}
        </PopUp>
        <PopUp showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.showCountriesPopUp} onClose={closePopUp}>
          <CountryPopUp onClose={closePopUp} packageSocCode={packageSocCode} />
        </PopUp>
        <PopUp
          showPopUp={
            localStatePopUpHasValue &&
            (popUpDisplay === popUpObject.updateTripDate || popUpDisplay === popUpObject.showChangeStartDateFamily)
          }
          onClose={closePopUp}>
          <ChangeStartPackageDatePopup
            buttonText={'עדכון תאריך התחלה'}
            isFamilyBonus={packageData.abroadPackageClient?.isFamilyBonus}
            fromPackageManager={true}
            startDate={changeDateToJSFormat()}
            action={(startDate) => updateSocPackage(startDate)}
            title={'עדכן תאריך התחלה'}
            description={
              packageData.abroadPackageClient?.isFamilyBonus
                ? `<span class="bold">רגע, זה חשוב</span><br /> חבילת בני משפחה לא יכולה להתחיל מעבר ל 7 ימים מתחילת החבילה הראשית`
                : ``
            }
            startDateParent={packageData.abroadPackageClient?.isFamilyBonus ? GetStartDateParent(packageData?.startDateParent) : null}
          />
        </PopUp>
        <PopUp showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.showCancelPackagePopUp} onClose={closePopUp}>
          {packageData.socType == AbroadSocType.ADDON_SOC ? (
            <CancelAddonPackagePopUp
              cancelPackage={cancelPackage}
              onClose={closePopUp}
              dwhParams={params}
              socTitle={packageData.customTitle}

            />
          ) : (
            <CancelPackagePopUp
              cancelPackage={cancelPackage}
              onClose={closePopUp}
            />
          )}
        </PopUp>
        <PopUp
          className='cancellation-notice-popup'
          showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.showAddonsCancellationNoticePopUp}
          onClose={closePopUp}>
          <AddonsCancellationNoticePopup
            addons={packageData.abroadPackageClient.addons}
            onClose={() => setPopUpDisplay(popUpObject.showCancelPackagePopUp)}
          />
        </PopUp>
        <PopUp
          showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.cantChangeStartDateFamilyOrCanCancelFamily}
          onClose={closePopUp}>
          <CantChangeStartDateFamilyOrCanCancelFamily
            cancelPackage={cancelPackage}
            onClose={closePopUp}
            isPermissive={canCancelPackageFamily}
          />
        </PopUp>
        <PopUp showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.showYouCannotCancelPackagePopUp} onClose={closePopUp}>
          <FailedUpdatePackage
            cancelPackage={cancelPackage}
            onClose={closePopUp}
            cancelPopUpText={packageData.permissions.cancelPopUpText}
          />
        </PopUp>
        <PopUp showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.displayStateInclude} onClose={closePopUp}>
          <AbroadStateInclude stateInclude={packageData?.abroadPackageClient?.countrySupportedDictionary} />
        </PopUp>


        <PopUp showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.failedCancelPackage} onClose={closePopUp}>
          <FailedCancelPackage onClose={closePopUp} resetSocPackageRemoveStatus={resetSocPackageRemoveStatus} />
        </PopUp>
        <PopUp showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.showCannotCancelWhileAbroadPopUp} onClose={closePopUp}>
          <CannotCancelWhileAbroad onClose={closePopUp} resetSocPackageRemoveStatus={resetSocPackageRemoveStatus} />
        </PopUp>
      </>
    );
  }

  function getRightDateArr(dateArr) {
    const secondDate = new Date(parseInt(dateArr[2]), parseInt(dateArr[1]) - 1, parseInt(dateArr[0]));
    const today = new Date();
    if (today.getTime() > secondDate.getTime()) return [today.getDate(), today.getMonth() + 1, today.getFullYear()];
    else return [dateArr[0], dateArr[1], dateArr[2]];
  }

  async function getPackageForFamilyMember() {
    // TBD send to ticket to buy with data
    gaEvent(
      gaParams.ABROAD_FAMILY_CLICK_ADD_FAMILY_MEMBER_PACKAGE.category,
      gaParams.ABROAD_FAMILY_CLICK_ADD_FAMILY_MEMBER_PACKAGE.eventType,
      familyMembersWithPackages.length,
    );

    if (packageData?.canPurchaseFamilyPackage === true) {
      const tempDatePickerStartJSFormat = packageData?.effDateILLocalTime.split('.');
      const correctDateArray = getRightDateArr(tempDatePickerStartJSFormat);
      const datePickerStartJSFormat = [correctDateArray[1], correctDateArray[0], correctDateArray[2]].join('/');
      const correctSelectedStartDate = [correctDateArray[0], correctDateArray[1], correctDateArray[2]].join('.');

      const objToUpdateTicket = {
        selectedPackage: packageData?.familyMemberDiscountedPackage,
        folderType: customerAbroadPackages.isBusiness ? customerTypeEnum.BUSINESS : customerTypeEnum.PRIVATE,
        selectedStartDate: correctSelectedStartDate,
        datePickerStartJSFormat,
        parentStartDate: [tempDatePickerStartJSFormat[1], tempDatePickerStartJSFormat[0], tempDatePickerStartJSFormat[2]].join('/'),
        countryList: packageData?.familyMemberDiscountedPackage?.countrySupportedList,
        socCodeParent: packageData?.abroadPackageClient?.socCode,
      };
      setLoading(true);
      await updateTicketFromPackageManager(objToUpdateTicket);
      await context.navigateTo(cellcomAbroad.epiStyleInitializationData?.urlToSaleBlock);
    }
  }

  function renderFamilyMemberMobileRow() {
    if (isBrowser) {
      return (familyMembersWithPackages || []).map(function (mobile, i) {
        return (
          <div className='phone-row' key={i}>
            <div className='phone'>{mobile} - </div>
            <div className='soc'>
              &nbsp;
              {packageData?.familyMemberDiscountedPackage?.familyPackageDescriptionFromPackageManager}
              &nbsp;
            </div>
          </div>
        );
      });
    } else {
      return (familyMembersWithPackages || []).map(function (mobile, i) {
        return (
          <div className='phone-row' key={i}>
            <div className='phone'>{mobile}</div>
            <div className='soc'>{packageData?.familyMemberDiscountedPackage?.familyPackageDescriptionFromPackageManager}</div>
          </div>
        );
      });
    }
  }

  function renderPicBoxes() {
    const icons = [images.smiley1, images.smiley2, images.smiley3, images.smiley4, images.smiley5];

    return (familyMembersWithPackages || []).map(function (element, i) {
      return (
        <div key={element} className={`slot plusPic`}>
          <Image className='slot-pic' src={icons[i]} />
        </div>
      );
    });
  }

  function renderAddBoxes() {
    const emptyBoxes = Array(boxesLeft).fill('');
    if (canPurchaseFamilyPackage) {
      return (emptyBoxes || []).map(function (element, i) {
        return (
          <div className='slot' key={i} onClick={() => getPackageForFamilyMember()}>
            הוספה +
          </div>
        );
      });
    }
    return null;
  }

  function renderBottomFamilyTxtLine() {
    if (familyMembersWithPackages.length > 0) {
      return (
        <div className='family-box-bottom'>לניהול החבילות המשפחתיות צריך להתנתק ולהתחבר לאזור חו"ל שלי עם מספר המנוי שרוצים לעדכן</div>
      );
    }
    return null;
  }

  function renderFamilyRelatedPackages() {
    return isBrowser ? (
      <div className='family-box-container'>
        <div className='family-box-upper'>
          <div className='txt-section'>
            <div className='family-header'>
              הטבת חו״ל <b> משפחתי </b>
              <AbroadTooltip tooltipText={toolTipFamily} tooltipId={'family-package-tooltip'} placement={'left'} />
            </div>
            <div className='family-p'>
              איזה כיף! קיבלת הטבה ל-5 בני המשפחה <br />
              במסגרת חבילת {packageData?.abroadPackageClient?.titleEpi}
            </div>
          </div>
          <div className='family-box-slots'>
            {renderPicBoxes()}
            {renderAddBoxes()}
          </div>
        </div>
        <div className='phone-section-mid'>{renderFamilyMemberMobileRow()}</div>
        {renderBottomFamilyTxtLine()}
      </div>
    ) : (
      <div className='family-box-container'>
        <div className='family-box-upper'>
          <div className='txt-section'>
            <div className='family-header'>
              הטבת חו״ל <b> משפחתי </b>
              <AbroadTooltip tooltipText={''} tooltipId={'family-package-tooltip'} placement={'left'} />
            </div>
            <div className='family-p'>
              איזה כיף! קיבלת הטבה ל5 בני משפחה <br />
              במסגרת חבילת {packageData?.abroadPackageClient?.titleEpi}
            </div>
          </div>
          <div className='family-box-slots'>
            {renderPicBoxes()}
            {renderAddBoxes()}
          </div>
        </div>
        <div className='phone-section-mid'>{renderFamilyMemberMobileRow()}</div>
        {renderBottomFamilyTxtLine()}
      </div>
    );
  }

  return (
    <>
      <div className='package-box'>
        {renderPackageWillOccurAt()}
        <div className={`top-box${arrowOpen ? ' open' : ''}`}>
          <div className='package-header-line'>
            <div className='package-header'>{packageTitle}</div>
            <Image alt='arrow' className={`arrow-img${arrowOpen ? ' open' : ''}`} src={images.arrow} onClick={() => expendData()}/>
          </div>
          {packageData.isFoundedByTheCompany && (
            <div className='full-funding' style={{ color: 'var(--theme-primary, #9631ff)', fontSize: '32px' }}>
              חבילה במימון החברה{' '}
            </div>
          )}
          {renderPackageData(packageData)}
        </div>
        {renderPackageAvailableActions(packageData)}
        {renderPopUps(packageData)}
      </div>
      {((hasFamilyBonus && canPurchaseFamilyPackage) || familyMembersWithPackages.length > 0) && renderFamilyRelatedPackages()}
    </>
  );
}

const mapStateToProps = (state) => ({
    cellcomAbroad: state.cellcomAbroad,
    otpData: state.cellcomAbroad.otpData,
    socPackageRemoveStatus: state.cellcomAbroad.socPackageRemoveStatus,
    businessId: state.cellcomAbroad.epiStyleInitializationData.businessSocPackageFolderId,
    goldBusinessSocPackageFolderId: state.cellcomAbroad.epiStyleInitializationData.goldBusinessSocPackageFolderId,
    privateId: state.cellcomAbroad.epiStyleInitializationData.privateSocPackageFolderId,
    mobile: state.cellcomAbroad.epiStyleInitializationData.businessIndividualLobby
      ? state.cellcomAbroad.businessIndividualData.selectedAccountNumber
      : state.cellcomAbroad.otpData.otpPhone || state.authentication.loginData.userDetails.contactNumber,
    updatedSocResultStatus: state.cellcomAbroad.updatedSocResultStatus,
    chosenSocForAction: state.cellcomAbroad.chosenSocForAction,
    isBusinessIndividual: state.cellcomAbroad.epiStyleInitializationData.businessIndividualLobby,
    portalsBlock: state.portalsBlock,
    userData: state.authentication?.loginData?.userDetails,

});

const mapDispatchToProps = {
  abroadCountriesSearched,
  removePackage,
  setLoading,
  updatePackage,
  updateTicketFromPackageManager,
  resetSocPackageRemoveStatus,
  saveToHistory,
  setChosenSocForAction,
  clearScreenILAddon,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExistingPackage);
